export enum AppRole {
  ADMIN = 'Admin',
  CHEF = 'Chef',
  EMPLOYER = 'Employer',
  OPERATOR = 'Operator'
}

export interface RoutePermission {
  path: string;
  roles: AppRole[];
}

export const ROUTE_PERMISSIONS: RoutePermission[] = [
  { path: '/admin/suppliers', roles: [AppRole.ADMIN, AppRole.CHEF] },
  { path: '/admin/suppliers/create', roles: [AppRole.ADMIN, AppRole.CHEF] },
  { path: '/admin/suppliers/:id', roles: [AppRole.ADMIN, AppRole.CHEF] },
  { path: '/planning/rules', roles: [AppRole.ADMIN, AppRole.CHEF] },
];
